var $ = require('jquery');
window.jQuery = $;

//js
require("@fancyapps/fancybox");

require("./js/tooltip.js");
require("./js/popup.js");
require("./js/table.js");
//fonts


// css
require('@fancyapps/fancybox/dist/jquery.fancybox.css');
require("./sass/style.scss");